import styled from "@emotion/styled";
import { Button } from "../../../components/UIKitComponents/Button/Button";

export const SideBarStyles = styled("div")`
  display: flex;
  width: 292px;
  flex-direction: column;

  .communication-sidebar {
    &__btn-back.--up {
      background-color: #e7e7ff;
      color: #4a5580;
      width: 292px;
      padding: 4px 0 8px 0;
      box-sizing: content-box;
      font-weight: bold;

      &:hover {
        opacity: 0.8;
      }
    }

    &__btn-back-icon-wrap {
      position: relative;
      display: inline-block;
      top: 5px;
      left: -7px;
    }
  }

  .tabs {
    height: 100%;
    margin-top: 10px;
    overflow: hidden;
    border: 1px solid rgb(226, 226, 238);
    border-radius: 6px;

    &__items {
      display: flex;
    }

    &__item {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;

      width: 146px;
      height: 46px;
      background-color: #efeffb;
      box-shadow: inset 1px -1px 3px 0 rgba(169, 169, 194, 0.05);

      &.--active {
        box-shadow: none;
        background-color: #fff;
      }
    }

    &__content {
      display: none;
      height: 100%;

      &.--active {
        display: block;
      }
    }
  }
`;

export const TabMsgNotifier = styled("div")`
  position: absolute;
  top: 6px;
  right: 7px;

  background-color: #ea1010;
  width: 10px;
  height: 10px;

  border-radius: 50%;
`;

export const ChangeSenderBtn = styled(Button)`
  background-color: #293359 !important;
  width: 292px;
  margin-top: 10px;
  padding: 6px 0;
  box-sizing: content-box;
`;

export const ChangeWorkspaceBtn = styled(Button)`
  background-color: #3333cc !important;
  width: 292px;
  max-height: 48px;
  margin-top: 10px;
  padding: 6px 0;
  box-sizing: content-box;
`;
